import React from 'react';
import './App.css';
import WalletSelect from './WalletSelect';
import LandingPage from './LandingPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/wallets" element={<WalletSelect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
